import React from "react";
import { View, FlatList } from "react-native";
import { s } from "react-native-size-matters";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";

const NotificationSkeleton: React.FC = () => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const renderSkeletonItem = () => (
    <View style={styles.challengeItem}>
      {/* Notification Content */}
      <View style={styles.challengeContent}>
        <Skeletons
          width={deviceSize === DEVICE_SIZES.XS ? "30px" : "50px"}
          height={deviceSize === DEVICE_SIZES.XS ? "30px" : "50px"}
          style={{ borderRadius: 5, marginRight: s(12) }}
        />
        <View style={{ flex: 1, gap: s(8) }}>
          <Skeletons
            width={deviceSize === DEVICE_SIZES.XS ? "85%" : "70%"}
            height={"16px"}
            style={{ borderRadius: s(4) }}
          />
        </View>
        <View style={styles.Time}>
          <Skeletons
            width={deviceSize === DEVICE_SIZES.XS ? "55px" : "120px"}
            height={"20px"}
            style={{ borderRadius: s(4) }}
          />
        </View>
      </View>

      <View style={styles.challengeHeader}>
        <Skeletons
          width={"120px"}
          height={"20px"}
          style={{ borderRadius: s(4) }}
        />
      </View>
    </View>
  );

  return (
    <View style={styles.container}>
      {/* Notification List */}
      <FlatList
        data={[...Array(5)]}
        renderItem={renderSkeletonItem}
        keyExtractor={(item, index) => index.toString()}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.listContainer}
      />
    </View>
  );
};

export default NotificationSkeleton;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: s(16),
      paddingTop: s(16),
    },
    headerContainer: {
      width: "100%",
      marginBottom: s(16),
    },
    notificationHeader: {
      flexDirection: "row",
      justifyContent: "flex-start",
      marginBottom: s(16),
    },
    listContainer: {
      paddingBottom: s(20),
    },
    challengeItem: {
      backgroundColor: AppColors.black_191919,
      borderRadius: s(8),
      padding: 10,
      marginBottom: 15,
      borderWidth: 1,
      borderColor: AppColors.gray_828282,
    },
    challengeHeader: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: s(12),
    },
    challengeContent: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 20,
    },
    challengeFooter: {
      flexDirection: "row",
      justifyContent: "flex-end",
      gap: s(12),
    },
    Time: {
      flexDirection: "row",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        paddingHorizontal: s(24),
      },
      challengeItem: {
        padding: s(20),
      },
      notificationHeader: {
        marginBottom: s(20),
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        paddingHorizontal: s(20),
      },
      challengeItem: {
        padding: s(18),
      },
      notificationHeader: {
        marginBottom: s(18),
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        paddingHorizontal: s(12),
      },
      challengeItem: {
        padding: s(14),
      },
      notificationHeader: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: s(8),
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        paddingHorizontal: s(10),
      },
      challengeItem: {
        padding: 10,
      },
      notificationHeader: {
        flexDirection: "column",
        gap: s(8),
        alignItems: "flex-start",
      },
      challengeHeader: {
        marginBottom: 0,
      },
      challengeContent: {
        marginBottom: 10,
      },
    },
  }
);
